<template>
  <div class="download">
    <h2>Download Passguard9000</h2>
    <p>
      Passguard9000 is coming soon! Stay tuned for the official release to
      experience effortless password management and data security.
    </p>
    <!-- <div class="cta-buttons">
      <button class="notify-btn" @click="notifyMe">Notify Me</button>
      <a href="#" class="learn-more">Learn More</a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "DownloadPage",
  methods: {
    notifyMe() {
      alert("We'll notify you once the app is live!");
    },
  },
};
</script>

<style scoped>
.download {
  text-align: center;
  padding: 4rem 2rem;
  color: #333;

  h2 {
    font-size: 2rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    color: #555555;
  }

  .cta-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .notify-btn {
      background-color: var(--primary-color);
      color: #fff;
      padding: 0.8rem 1.5rem;
      border: none;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      transition: background-color 0.3s, transform 0.2s;

      &:hover {
        background-color: darken(var(--primary-color), 10%);
        transform: translateY(-2px);
      }
    }

    .learn-more {
      color: var(--primary-color);
      font-size: 1rem;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: darken(var(--primary-color), 10%);
      }
    }
  }

  /* Responsive Styles */
  @media (max-width: 768px) {
    .cta-buttons {
      flex-direction: column;
    }

    .notify-btn,
    .learn-more {
      width: 100%;
      max-width: 300px;
    }
  }
}
</style>
